import { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

/** Analytics access is independent of page access, even when both share a query. */
export const getViewPageContentError = (
	error: ApolloErrorInterop | undefined,
	contentId: string,
	resolvedContentId: string | null | undefined,
): ApolloErrorInterop | undefined => {
	// Never use missing content or the previous page's data to dismiss a permission failure.
	if (!error || !contentId || resolvedContentId !== contentId) {
		return error;
	}

	const graphQLErrors = error.graphQLErrors.filter((graphQLError) => {
		if (graphQLError.path?.[0] === 'contentAnalyticsViewers' && isUnauthorizedError(graphQLError)) {
			markErrorAsHandled(graphQLError);
			return false;
		}
		return true;
	});

	if (graphQLErrors.length === error.graphQLErrors.length) {
		return error;
	}
	if (!graphQLErrors.length && !error.networkError) {
		markErrorAsHandled(error);
		return undefined;
	}

	return new ApolloErrorInterop({
		graphQLErrors,
		networkError: error.networkError,
		extraInfo: error.extraInfo,
	});
};
